/**
 * ModulePlaceableState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModulePlaceableState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModulePlaceableState {
  NONE    = -1,
  DEFAULT =  0,
  OPEN    =  1,
  CLOSED  =  2,
  DEAD    =  3,
  ON      =  4,
  OFF     =  5
};